module.exports = __webpack_public_path__ + "static/media/Iconly-Bold-Paper-Grey.b7f5e511.svg";